import axios from "axios";
import React, { useEffect, useState } from "react";
import "../../../../../Assets/Styles/DashboardHead.scss";
import { Config } from "../../../../../Config";
import ProfileMenu from "../ProfileMenu/ProfileMenu";
import { ReactComponent as ChatbotIcon } from "../../../../../Assets/Images/Chatbot.svg";
import LanguageMenu from "../LanguageMenu/LanguageMenu";
import HeaderGuide from "../../UserGuide/Components/HeaderGuide";
import AskmeIcon from "../../../../../Assets/Images/Chatbot-ask-me.svg";

const DashboardHead = (props) => {
  const [ProfileMenuIsOpen, setProfileMenuIsOpen] = useState(false);
  const [EmployeePos, setEmployeePos] = useState();
  const [LangMenuIsOpen, setLangMenuIsOpen] = useState(false); // used for displaying languages dropdown to change user's preferred language

  useEffect(() => {
    fetchEmpPositionInfo();
  }, []);

  const handleCountDisplay = (Count) => {
    if (Count >= 100) {
      return "99+";
    } else {
      return Count;
    }
  };

  const fetchEmpPositionInfo = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/current-position",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setEmployeePos(Res.data.title);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  // {props.HeaderGuideIsOpen} these conditions are only implemented for differentiating between the
  // case where the user walkthrough (user guide) is open and we want to either apply styles or
  // disable any functionalities.
  return (
    <>
      {props.HeaderGuideIsOpen ? (
        <div className="overlay" style={{ zIndex: "99" }}></div>
      ) : null}
      <div
        className="header is-desktop"
        style={props.NavBookmarksGuideIsOpen ? { zIndex: 0 } : null}
      >
        {props.HeaderGuideIsOpen ? (
          <div className="header-shadow-box"></div>
        ) : null}
        {props.HeaderGuideIsOpen ? (
          <HeaderGuide
            LangData={props.LangData}
            TogglePreviousDialog={() => props.ToggleSeventhGuide()}
            CloseGuide={() => props.CloseGuide()}
            JumpToStep={(Step) => props.JumpToStep(Step)}
            UpdateWalkthrough={(Bool) => props.UpdateWalkthrough(Bool)}
            HasAdditionalStep={props.HasAdditionalStep}
          />
        ) : null}
        <span className="profile-menu-holder">
          {ProfileMenuIsOpen ? (
            <ProfileMenu
              UserInfo={props.UserInfo}
              Close={() => setProfileMenuIsOpen(false)}
              LangData={props.LangData}
              EmployeePos={EmployeePos}
              UpdateWalkthrough={(Bool) => props.UpdateWalkthrough(Bool)}
            />
          ) : null}
        </span>
        <span className="profile-menu-holder">
          {LangMenuIsOpen ? (
            <LanguageMenu
              SelectedLanguage={props.UserLanguage}
              Close={() => setLangMenuIsOpen(false)}
              SetLanguage={(Lang) => props.SetPreferredLanguage(Lang)}
            />
          ) : null}
        </span>
        {props.UserInfo.imageThumbnailUrl === null ? (
          <span
            onClick={() =>
              props.HeaderGuideIsOpen ? null : setProfileMenuIsOpen(true)
            }
            style={{
              backgroundColor: props.UserInfo.backgroundColorCode,
              color: props.UserInfo.textColorCode,
            }}
            className="user-avatar avatar-placeholder"
          >
            {props.UserInfo.firstName.slice(0, 1).toUpperCase() +
              props.UserInfo.lastName.slice(0, 1).toUpperCase()}
          </span>
        ) : (
          <img
            className="user-avatar user-image"
            alt=""
            onClick={() =>
              props.HeaderGuideIsOpen ? null : setProfileMenuIsOpen(true)
            }
            src={props.UserInfo.imageThumbnailUrl}
          />
        )}
        <button
          className="notifications-trigger"
          onClick={() => props.ToggleAskMeBot()}
        >
          <img alt="" src={AskmeIcon} />
        </button>
        <button
          onClick={props.HeaderGuideIsOpen ? null : () => props.ToggleChatbot()}
        >
          <ChatbotIcon />
        </button>
        <button
          className={
            props.HasNotifications
              ? "notifications-trigger with-notifs"
              : "notifications-trigger"
          }
          onClick={
            props.HeaderGuideIsOpen ? null : () => props.ToggleNotifications()
          }
        >
          <i className="feather-bell"></i>
          {props.UnreadEventsNotifs + props.UnreadMessagesNotifs > 0 ? (
            <span className="reminder-spot">
              {handleCountDisplay(
                props.UnreadEventsNotifs + props.UnreadMessagesNotifs
              )}
            </span>
          ) : null}
        </button>
        <button
          className="lang-toggle"
          onClick={
            props.HeaderGuideIsOpen ? null : () => setLangMenuIsOpen(true)
          }
        >
          <i className="feather-globe"></i>
          <p>{props.UserLanguage}</p>
        </button>
      </div>
    </>
  );
};
export default DashboardHead;
